// extracted by mini-css-extract-plugin
module.exports = {"avatar":"dialog-group-total-duration_avatar_1U69T"};